import _Divider from "@arco-design/web-react/es/Divider";
import _Link from "@arco-design/web-react/es/Link";
import _Typography from "@arco-design/web-react/es/Typography";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import _Message from "@arco-design/web-react/es/Message";
import _Select from "@arco-design/web-react/es/Select";
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { getPublishLog } from '@src/utils/api/publish';
import usePreviewVersion from '@src/hooks/usePrviewVersion';
import useFromQuery from '@src/hooks/useFromQuery';
import useLocale from '@src/hooks/useLocale';
import locale from './locale';
var Option = _Select.Option;
export default function HistoryPreviewSelect(props) {
  var themeInfo = props.themeInfo;
  var _a = __read(useState(''), 2),
    curVersion = _a[0],
    setCurVersion = _a[1];
  var _b = __read(useState([]), 2),
    versionList = _b[0],
    setVersionList = _b[1];
  var t = useLocale(locale).t;
  var history = useHistory();
  var encodeFrom = useFromQuery();
  var currentPreviewVersion = usePreviewVersion().currentPreviewVersion;
  var changePreviewVersion = function changePreviewVersion(version) {
    if (version !== themeInfo.version) {
      history.push(encodeFrom ? "?previewVersion=" + version + "&" + encodeFrom : "?previewVersion=" + version);
    } else {
      history.push(encodeFrom ? "?" + encodeFrom : '?');
    }
    location.reload();
  };
  useEffect(function () {
    if (currentPreviewVersion) {
      setCurVersion(currentPreviewVersion);
      _Message.info("" + t['preview.version.current'] + currentPreviewVersion);
    } else {
      setCurVersion(String(themeInfo.version));
    }
    getPublishLog({
      themeId: themeInfo.themeId,
      onlyList: true
    }).then(function (res) {
      setVersionList(res.list);
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, versionList.length > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Tooltip, {
    content: t['preview.version']
  }, /*#__PURE__*/React.createElement(_Select, {
    onChange: changePreviewVersion,
    value: curVersion,
    triggerElement: /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'inline-block',
        minWidth: 100
      }
    }, /*#__PURE__*/React.createElement(_Typography.Paragraph, {
      tabIndex: 0,
      style: {
        marginBottom: 0
      }
    }, t['preview.version'], "\uFF1A", /*#__PURE__*/React.createElement(_Link, {
      style: {
        color: 'rgb(var(--link-6))'
      }
    }, curVersion)))
  }, versionList.map(function (option) {
    return /*#__PURE__*/React.createElement(Option, {
      key: option.version,
      value: option.version
    }, option.version);
  }))), /*#__PURE__*/React.createElement(_Divider, {
    type: "vertical"
  })) : null);
}